import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "battery",
  "use": "battery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"battery\">\n<path d=\"M17,19H3c-1.7,0-3-1.3-3-3V8c0-1.7,1.3-3,3-3h14c1.7,0,3,1.3,3,3v8C20,17.7,18.7,19,17,19z M3,7C2.4,7,2,7.4,2,8v8\n\tc0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1H3z\" />\n<path d=\"M23,14c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2C24,13.6,23.6,14,23,14z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol